import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  type Language,
  SUPPORTED_LANGUAGES,
  LANGUAGE_STORAGE_KEY,
} from "Translations/languageConfig";
import { getInitialLanguage } from "Translations/languageUtils";
import { setLocalStorageItem } from "Utils/Storage/LocalStorage/SecureLocalStorage";

export const useLanguage = () => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState<Language>(() => {
    return getInitialLanguage();
  });

  const changeLanguage = useCallback(
    (language: Language) => {
      if (!SUPPORTED_LANGUAGES.includes(language)) {
        console.warn(`Unsupported language: ${language}`);
        return;
      }

      // Update i18n
      i18n.changeLanguage(language);

      // Update state
      setCurrentLanguage(language);

      // Store in localStorage
      setLocalStorageItem(LANGUAGE_STORAGE_KEY, language);
    },
    [i18n],
  );

  // Sync i18n language with our state on mount
  useEffect(() => {
    if (i18n.language !== currentLanguage) {
      i18n.changeLanguage(currentLanguage);
    }
  }, [i18n, currentLanguage]);

  return {
    currentLanguage,
    changeLanguage,
    supportedLanguages: SUPPORTED_LANGUAGES,
    getInitialLanguage,
  };
};
